import React from 'react'
import MasterLayout from 'views/MasterLayout'
import FinanceRouter from './Router'

export default function FinanceLayout(props) {
  return (
    <MasterLayout>
      <FinanceRouter match={props.match}/>
    </MasterLayout>
  )
}
